<template>
  <div>
    <div class="tableBlock">
      <div class="cellBlock">
        <div class="popoStyle">
          <div class="contentMsg" v-html="message">
          </div>
          <div class="btnContainerPopup">
            <Button @click="onOkClick" class="btn p-button-raised" label="Ok" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

.popoStyle button.btn.p-button-raised.p-button.p-component.p-button-text-only {
    padding: 0;
    line-height: normal;
    font-size: 100%;
}

.Vue-Toastification__toast.Vue-Toastification__toast--info,
.Vue-Toastification__toast.Vue-Toastification__toast--error {
    animation-duration: 0s !important;
}
.Vue-Toastification__toast--info button.Vue-Toastification__close-button,
.Vue-Toastification__toast--error button.Vue-Toastification__close-button {
    display: none;
}

.Vue-Toastification__toast.Vue-Toastification__toast--info.bottom-left,
.Vue-Toastification__toast.Vue-Toastification__toast--error.bottom-left {
    height: 100%;
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    max-width: 100%;
    max-height: 100%;
    background: rgba(0, 0, 0, 0.71);
}

.tableBlock {
    display: table;
    width: 100%;
    height: 100%;
}

.cellBlock {
    display: table-cell;
    vertical-align: middle;
    height: 100vh;
    width: 100%;
}

.btnContainerPopup {
    margin: 20px 0 10px 0;
    text-align: center;
}

.popoStyle {
    width: 390px;
    background: #fff;
    margin: 0 auto;
    color: #000;
    padding: 20px;
    border-radius: 5px;
    text-align: center;
    overflow: hidden;
}

.Vue-Toastification__toast--info.bottom-left .popoStyle {
    background: #ffffff;
    color: #5a5a5a;
}
.Vue-Toastification__toast--error.bottom-left .popoStyle {
    background: #ffffff;
    color: #cb0a0a;
}
</style>

<script setup>
const props = defineProps({
  message: {
    type: String,
    required: true,
  },
});

// 2. Define emits using defineEmits
const emit = defineEmits(['close-toast', 'okClicked']);

// 3. Define the event handler directly
const onOkClick = () => {
  emit('close-toast'); // Emits to vue-toastification to close the toast
  emit('okClicked');   // Emits for your custom logic (e.g., the callback in notifyError)
};
</script>